import { Map, AdvancedMarker, useMap, useMapsLibrary } from '@vis.gl/react-google-maps';
import { connect } from 'react-redux';
import { useContext } from 'react';

import LocationContext from '../../../locationContext';
import classes from './GoogleMap.module.css';
import * as actions from '../../../store/actions';
import { useEffect, useRef } from 'react';

const GoogleMap = (props) => {
    const location = useContext(LocationContext);
    const map = useMap();
    const routesLib = useMapsLibrary("routes");
    const defaultCenter = { lat: 30, lng: 31 };
    const directionsRendererRef = useRef(null);
    useEffect(() => {
        if (!map || !routesLib) return;

        if (location.pickupPlace) {
            map.fitBounds(location.pickupPlace.geometry?.viewport);
        }

        if (location.dropOffPlace) {
            map.fitBounds(location.dropOffPlace.geometry?.viewport);
        }

        if (!location.pickupPlace && !location.dropOffPlace) {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        if (position) {
                            const userLocation = { lat: position.coords.latitude, lng: position.coords.longitude, };
                            map.setCenter(userLocation);
                        }
                    },
                );

            }
        } else if (location.pickupPlace && location.dropOffPlace) {

            const directionsService = new routesLib.DirectionsService();

            if (!directionsRendererRef.current) {
                directionsRendererRef.current = new routesLib.DirectionsRenderer();
                directionsRendererRef.current.setMap(map);
            }

            directionsRendererRef.current.setDirections({ routes: [] });
            directionsService.route(
                {
                    origin: {
                        lat: location.pickupPlace.geometry.location.lat(),
                        lng: location.pickupPlace.geometry.location.lng(),
                    },
                    destination: {
                        lat: location.dropOffPlace.geometry.location.lat(),
                        lng: location.dropOffPlace.geometry.location.lng(),
                    },
                    travelMode: window.google.maps.TravelMode.DRIVING,
                }
            ).then((response) => {
                const leg = response.routes[0].legs[0];
                props.setDurationAndDistance(leg);

                directionsRendererRef.current.setDirections(response);
            });
        }
    }, [map, routesLib,location.pickupPlace, location.dropOffPlace]);

    return (
        <div className={classes.GoogleMap}>
            <Map
                mapId={"bf51a910020fa25a"}
                defaultZoom={13}
                defaultCenter={defaultCenter}
            >
                {
                    location.pickupPlace
                        ? <AdvancedMarker position={location.pickupPlace.geometry?.location} />
                        : null
                }
                {
                    location.dropOffPlace
                        ? <AdvancedMarker position={location.dropOffPlace.geometry?.location} />
                        : null
                }

            </Map>
        </div>
    );
}

/* const mapStateToProps = (state) => {
    return {
        pickupPlace: state.locations.pickupLocation,
        dropOffPlace: state.locations.dropoffLocation,
    }
};
 */
const mapDistpatchToProps = (dispatch) => {
    return {
        setDurationAndDistance: (leg) => dispatch(actions.setDurationAndDistance(leg)),
    };
};


export default connect(null, mapDistpatchToProps)(GoogleMap);

/* class GoogleMap extends Component {
    constructor(props) {
        super(props);
        this.directionsRenderer = null;
        this.directionsService = null;
    }

    state = {
        defaultCenter: { lat: 30, lng: 31 },
    }

    componentDidMount() {
        this.directionsService = new this.props.routes.DirectionsService();
        this.directionsRenderer = new this.props.routes.DirectionsRenderer();
    }

    getCurrentLocation = () => {
        if (!this.props.pickupPlace && !this.props.dropOffPlace) {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        if (position) {
                            const userLocation = { lat: position.coords.latitude, lng: position.coords.longitude, };
                            this.props.map.setCenter(userLocation);
                        }
                    },
                );

            }
        }
    }

    setupPuiclupLocationIcon = () => {
        if (this.props.pickupPlace) {
            if (this.props.map) {
                this.props.map.fitBounds(this.props.pickupPlace.geometry?.viewport);
            }
        }
    }

    setupDropOffLocationIcon = () => {
        if (this.props.dropOffPlace) {
            if (this.props.map) {
                this.props.map.fitBounds(this.props.dropOffPlace.geometry?.viewport);
            }
        }
    }

    componentDidUpdate(prevProps) {
        this.getCurrentLocation();

        this.directionsRenderer.setMap(this.props.map);

        if (this.props.pickupPlace !== prevProps.pickupPlace || this.props.dropOffPlace !== prevProps.dropOffPlace) {
            if (this.props.pickupPlace && this.props.dropOffPlace) {

                this.directionsService.route(
                    {
                        origin: {
                            lat: this.props.pickupPlace.geometry.location.lat(),
                            lng: this.props.pickupPlace.geometry.location.lng(),
                        },
                        destination: {
                            lat: this.props.dropOffPlace.geometry.location.lat(),
                            lng: this.props.dropOffPlace.geometry.location.lng(),
                        },
                        travelMode: window.google.maps.TravelMode.DRIVING,
                    }
                ).then((response) => {
                    const leg = response.routes[0].legs[0];
                    this.props.setDurationAndDistance(leg);
                    this.directionsRenderer.setDirections({ routes: [] });
                    this.directionsRenderer.setDirections(response);
                });

            }
        }
    }

    render() {
        this.setupPuiclupLocationIcon();
        this.setupDropOffLocationIcon();
        return (
            <div className={classes.GoogleMap}>
                <Map
                    mapId={"bf51a910020fa25a"}
                    ref={this.mapRef}
                    defaultZoom={13}
                    defaultCenter={this.state.defaultCenter}
                >
                    {
                        this.props.pickupPlace
                            ? <AdvancedMarker position={this.props.pickupPlace.geometry?.location} />
                            : null
                    }
                    {
                        this.props.dropOffPlace
                            ? <AdvancedMarker position={this.props.dropOffPlace.geometry?.location} />
                            : null
                    }

                </Map>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        pickupPlace: state.locations.pickupLocation,
        dropOffPlace: state.locations.dropoffLocation,
    }
};

const mapDistpatchToProps = (dispatch) => {
    return {
        setDurationAndDistance: (leg) => dispatch(actions.setDurationAndDistance(leg)),
    };
};


export default connect(mapStateToProps, mapDistpatchToProps)(withMapsLibrary(withMap(GoogleMap))); */